export const flatten = (list: any[]): any[] =>
  list.reduce((a: any[], b: any) => a.concat(Array.isArray(b) ? flatten(b) : b), []);
